"use client"
import ErrorComponent from "components/error-handler"

export default function Error({ error }: { error: Error }) {
  return (
    <ErrorComponent error={error} tags={{ context: "root_error_boundary" }} />
  )
}
